import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import '../WorkflowView.css';
import {
  formatWorkflowConditionText,
  getWorkflowConditionIcon,
} from '../WorkflowConditionEnum';
import {
  formatWorkflowActionText,
  getWorkflowActionIcon,
  getWorkflowActionTitle,
} from '../WorkflowActionEnum';

// Helper function to format event text
const formatEventText = (event) => {
  const labels = {
    'DOCUMENT_COMPLETED': 'When a document completes processing'
  };
  return labels[event] || event;
};

const WorkflowDiagram = ({ workflow, activeUsers, teams }) => {
  if (!workflow) {
    return (
      <div className="custom-workflow-diagram">
        <div className="workflow-empty-state">
          <p>No workflow defined</p>
        </div>
      </div>
    );
  }

  const conditions = workflow.conditions || [];
  const actions = workflow.actions || [];

  return (
    <div className="custom-workflow-diagram">
      {/* Trigger */}
      <div className="workflow-step">
        <div className="workflow-card workflow-trigger">
          <div className="workflow-card-content">
            <div className="workflow-card-title">Trigger</div>
            <div className="workflow-card-text">{formatEventText(workflow.event)}</div>
          </div>
        </div>
      </div>

      {/* Arrow */}
      {(conditions.length > 0 || actions.length > 0) && (
        <div className="workflow-arrow">
          <FontAwesomeIcon icon={faArrowDown} />
        </div>
      )}

      {/* Conditions Group */}
      {conditions.length > 0 && (
        <>
          <div className="workflow-step">
            <div className="workflow-conditions-group">
              <div className="workflow-conditions-header">
                <div className="workflow-card-title">All Conditions Must Be Met</div>
                <div className="workflow-conditions-badge">{conditions.length} condition{conditions.length !== 1 ? 's' : ''}</div>
              </div>
              <div className="workflow-conditions-list">
                {conditions.map((condition, index) => (
                  <div key={index} className="workflow-condition-item">
                    <div className="condition-icon">
                      <FontAwesomeIcon icon={getWorkflowConditionIcon(condition)} />
                    </div>
                    <div className="condition-text">
                      {formatWorkflowConditionText(condition, activeUsers, teams)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Arrow */}
          {actions.length > 0 && (
            <div className="workflow-arrow">
              <FontAwesomeIcon icon={faArrowDown} />
            </div>
          )}
        </>
      )}

      {/* Actions */}
      {actions.length > 0 && (
        <div className="workflow-step">
          <div className="workflow-actions-header">
            <div className="workflow-card-title">Then Execute Actions in Order</div>
            <div className="workflow-actions-badge">{actions.length} action{actions.length !== 1 ? 's' : ''}</div>
          </div>
          <div className="workflow-actions-list">
            {actions.map((action, index) => (
              <React.Fragment key={index}>
                <div className="workflow-card workflow-action">
                  <div className="workflow-action-number">{index + 1}</div>
                  <div className="workflow-card-content">
                    <div className="workflow-card-title">{getWorkflowActionTitle(action)}</div>
                    <div className="workflow-card-text">{formatWorkflowActionText(action, activeUsers, teams)}</div>
                  </div>
                </div>
                {index < actions.length - 1 && (
                  <div className="workflow-arrow workflow-arrow-small">
                    <FontAwesomeIcon icon={faArrowDown} />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      )}

      {/* Empty state for no conditions or actions */}
      {conditions.length === 0 && actions.length === 0 && (
        <div className="workflow-empty-state">
          <p>Add conditions and actions to build your workflow</p>
        </div>
      )}
    </div>
  );
};

export default WorkflowDiagram;
